export default "__VITE_ASSET__C0g_IjRZ__"